import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/TeacherProfilePage.css';
import { useNavigate } from 'react-router-dom';

const StockBranchDetailPage = ({isSidebarCollapsed}) => {
    const { inventoryBranchId } = useParams(); 
    const [inventoryBranch, setInventoryBranch] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchInventoryDetails = async () => {
            try {
                
                console.log("Inventory Branch ID:", inventoryBranchId);
                const id = parseInt(inventoryBranchId, 10);
                const response = await api.get(`/inventory/branchDetail/${id}`);
                setInventoryBranch(response.data?.data[0] || null);
            } catch (error) {
                console.error("Failed to fetch teacher details", error);
            }
        };
        fetchInventoryDetails();
    }, [inventoryBranchId]);

    if (!inventoryBranch) return <p>Loading inventory details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="page-title">Stock Branch Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Stock Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Item Name</td>
                                <td>:</td>
                                <td>{inventoryBranch.Inventory.item_name}</td>
                            </tr>
                            <tr>
                                <td>Item Type</td>
                                <td>:</td>
                                <td>{inventoryBranch.Inventory.item_type}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{inventoryBranch.Branch.branch_name}</td>
                            </tr>
                            <tr>
                                <td>Total Stock</td>
                                <td>:</td>
                                <td>{inventoryBranch.total_stock}</td>
                            </tr>
                            <tr>
                                <td>Last Update</td>
                                <td>:</td>
                                <td>{moment(inventoryBranch.changed_on).format('DD MMMM YYYY  HH:mm:ss')}</td>
                            </tr>
                            <tr>
                                <td>Last Update By</td>
                                <td>:</td>
                                <td>{inventoryBranch.changed_by}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="create-student-table">
                    <h3 className="section-header">Transaction Details</h3>
                    <table>
                        <thead>
                        <tr>
                        <th className='table-center-align'>No</th>
                            <th className='table-center-align'>Transaction Date</th>
                            <th className='table-center-align'>In</th>
                            <th className='table-center-align'>Out</th>
                            <th className='table-center-align'>Quantity</th>
                            <th className='table-center-align'>Sent By</th>
                            <th className='table-center-align'>Received By</th>
                        </tr>
                        </thead>
                        <tbody>
                        {inventoryBranch.InventoryBranchHistories.map((inventoryHistory, index) => (
                            <tr key={inventoryHistory.inventory_history_id}>
                                <td className="no-column">{index + 1}</td>
                                <td>{moment(inventoryHistory.send_on).format('DD MMMM YYYY  HH:mm:ss')}</td>
                                <td class="no-column">{inventoryHistory.transaction_type === 'RECEIVED' ? 'V' : 'X'}</td>
                                <td class="no-column">{inventoryHistory.transaction_type === 'RECEIVED' ? 'X' : 'V'}</td>
                                <td className='table-right-align'>{inventoryHistory.item_quantity}</td>
                                <td className='table-right-align'>{inventoryHistory.send_by}</td>
                                <td className='table-right-align'>{inventoryHistory.received_by}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="search-container">
                    
                    <button className="profile-button" onClick={() => navigate('/inventoryBranch/list')}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default StockBranchDetailPage;
